import React from "react";
import { LoadingIcon } from "../../../components";
import { DatePicker, Tabs } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/en";

import isBetween from "dayjs/plugin/isBetween";
import { BroccoliTable } from "./Table";
import HeadSizeDashboardContent from "./HeadSizeDashboardContent";
import StandCountDashboardContent from "./StandCountDashboardContent";

dayjs.extend(isBetween);

const { RangePicker } = DatePicker;

const DashboardContent = ({
  currentOrg,
  currentSite,
  headSizeGraphData,
  standCountGraphData,
  dropdownLoading,
  dateList,
  siteMetadata,
  currentCrop,
  currentGreenhouse,
  currentPlot,
  currentDate,
  activeTab,
  setActiveTab,
}) => {
  const tabItems = [
    {
      label: "Head Size",
      key: "headSize",
      children: (
        <HeadSizeDashboardContent
          currentOrg={currentOrg}
          currentSite={currentSite}
          graphData={headSizeGraphData}
          dropdownLoading={dropdownLoading}
          dateList={dateList}
          siteMetadata={siteMetadata}
          currentCrop={currentCrop}
          currentGreenhouse={currentGreenhouse}
          currentPlot={currentPlot}
          currentDate={currentDate}
        />
      ),
    },
    {
      label: "Stand Count",
      key: "standCount",
      children: (
        <StandCountDashboardContent
          currentOrg={currentOrg}
          currentSite={currentSite}
          graphData={standCountGraphData}
          dropdownLoading={dropdownLoading}
          dateList={dateList}
          siteMetadata={siteMetadata}
          currentCrop={currentCrop}
          currentGreenhouse={currentGreenhouse}
          currentPlot={currentPlot}
        />
      ),
    },
  ];

  return (
    <>
      {dropdownLoading ? (
        <LoadingIcon height="200px" />
      ) : (
        <div className="w-full flex flex-col items-center">
          {/* Table Section */}
          <BroccoliTable
            siteMetadata={siteMetadata}
            currentCrop={currentCrop}
            currentGreenhouse={currentGreenhouse}
            currentPlot={currentPlot}
          ></BroccoliTable>

          <Tabs
            activeKey={activeTab}
            onChange={(key) => setActiveTab(key)}
            className="w-full"
            tabBarStyle={{ width: "100%" }}
            items={tabItems} // Use the items prop to define tabs
          />
        </div>
      )}
    </>
  );
};

export default DashboardContent;
